import { render, staticRenderFns } from "./bf-steps.vue?vue&type=template&id=34689732&"
import script from "./bf-steps.vue?vue&type=script&lang=js&"
export * from "./bf-steps.vue?vue&type=script&lang=js&"
import style0 from "./bf-steps.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LnCustomButton: require('/usr/src/app/components/ln-custom-button.vue').default})
